<div class="relative min-h-screen text-white">

    <div class="relative z-20 overflow-hidden">
        <app-fp-navbar class="relative z-30"/>
        <router-outlet />
        <app-fp-footer class="relative z-30"/>
    </div>

</div>
